import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "header flex -bwn" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content mt_5" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 1 }

import { Warning, CircleClose } from '@element-plus/icons-vue'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRtfix } from '@/store'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: Number, // 1：同步订单数据  2：一件下单  3：开启自动同步订单
    default: 1
  },
  placement: {
    type: String,
    default: 'bottom'
  },
  width: {
    type: String,
    default: '300px'
  },
  popIndex: {
    type: Number,
    default: 0
  }
},
  setup(__props, { expose }) {

const props = __props
const store = useStore()

const isSub = store.getters.isSub // 是否是子账号
const membership = store.getters.membership // 会员信息
const popverVisible = ref(false)
const open = () => {
  popverVisible.value = true
}
const close = () => {
  popverVisible.value = false
}

expose({ open, close })

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom-start",
    "popper-class": "member-popver",
    width: "300px",
    visible: popverVisible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((popverVisible).value = $event)),
    trigger: "click"
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_icon, {
              color: "#E6A23C",
              class: "icon-style",
              size: "14px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Warning))
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('说明2')), 1)
          ]),
          _createVNode(_component_el_icon, {
            onClick: close,
            color: "#F56C6C",
            size: "14px",
            style: {"cursor":"pointer"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CircleClose))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (__props.type === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(isSub))
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      innerHTML: _unref(t)('尊敬的用户，您于T变更为非会员用户，已授权的API被禁用，需办理会员成功后，方可同步订单数据，请联系主账号办理')
            .replace('T',`<span style='color:#eb4545'>${_unref(membership).updateTime}</span>`).replace('请联系主账号办理',`<b>请联系主账号办理</b>`)
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员成功后，方可同订单数据')), 1))
              ]))
            : (__props.type === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_unref(isSub))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        innerHTML: _unref(t)('尊敬的用户，您需办理会员后，方可下单，请联系主账号办理').replace('请联系主账号办理',`<b>请联系主账号办理</b>`)
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员后，方可下单')), 1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_unref(isSub))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        innerHTML: _unref(t)('尊敬的用户，您需办理会员成功后，方可开启自动同步下单，请联系主账号办理').replace('请联系主账号办理',`<b>请联系主账号办理</b>`)
                      }, null, 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员成功后，方可开启自动同步下单')), 1))
                ]))
        ]),
        _createVNode(_component_router_link, {
          to: _unref(useRtfix)('VipLevel')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { class: "btn mt_5" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('办理会员')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})